/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type FileSubmitPreSignedUploadInput = {
    key: string;
};
export type UploadTourVideoSubmitPreSignedUploadMutationVariables = {
    input: FileSubmitPreSignedUploadInput;
};
export type UploadTourVideoSubmitPreSignedUploadMutationResponse = {
    readonly fileSubmitPreSignedUpload: {
        readonly bucketURL: string;
        readonly tourId: string;
    };
};
export type UploadTourVideoSubmitPreSignedUploadMutation = {
    readonly response: UploadTourVideoSubmitPreSignedUploadMutationResponse;
    readonly variables: UploadTourVideoSubmitPreSignedUploadMutationVariables;
};



/*
mutation UploadTourVideoSubmitPreSignedUploadMutation(
  $input: FileSubmitPreSignedUploadInput!
) {
  fileSubmitPreSignedUpload(input: $input) {
    bucketURL
    tourId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "FileSubmitPreSignedUploadPayload",
    "kind": "LinkedField",
    "name": "fileSubmitPreSignedUpload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bucketURL",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tourId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UploadTourVideoSubmitPreSignedUploadMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UploadTourVideoSubmitPreSignedUploadMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "83b4bc0b58e4d93f0a8ced3618e30122",
    "id": null,
    "metadata": {},
    "name": "UploadTourVideoSubmitPreSignedUploadMutation",
    "operationKind": "mutation",
    "text": "mutation UploadTourVideoSubmitPreSignedUploadMutation(\n  $input: FileSubmitPreSignedUploadInput!\n) {\n  fileSubmitPreSignedUpload(input: $input) {\n    bucketURL\n    tourId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'fa548216cc2354e64751c92b7884f166';
export default node;
